import { render, staticRenderFns } from "./BtnExcluirRahtEmpresa.vue?vue&type=template&id=4fb65262"
import script from "./BtnExcluirRahtEmpresa.vue?vue&type=script&lang=js"
export * from "./BtnExcluirRahtEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports